// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/Main-image.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Main_MainTablet__xJmiN {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 208px);
  position: relative;
}
.Main_MainTablet__xJmiN .Main_horizont__yv9RY .Main_text__wGXgG {
  position: absolute;
  top: 137px;
  left: 24px;
}
.Main_MainTablet__xJmiN .Main_horizont__yv9RY .Main_text__wGXgG .Main_iconTablet__BpIYQ {
  width: 60vw;
}
.Main_MainTablet__xJmiN .Main_horizont__yv9RY .Main_text__wGXgG .Main_subTitle__nWLpH {
  width: 280px;
  margin-top: 30px;
  margin-left: 10px;
}
.Main_MainTablet__xJmiN .Main_horizont__yv9RY .Main_photo__3lo9F {
  width: 90vw;
  height: 70vh;
  position: absolute;
  right: 0;
  bottom: 0;
  background-position: right 0 bottom 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 51vh;
}
.Main_MainTablet__xJmiN .Main_vertical__O-m14 .Main_text__wGXgG {
  position: absolute;
  top: 117px;
  left: 24px;
}
.Main_MainTablet__xJmiN .Main_vertical__O-m14 .Main_text__wGXgG .Main_iconTablet__BpIYQ {
  width: 72vw;
}
.Main_MainTablet__xJmiN .Main_vertical__O-m14 .Main_text__wGXgG .Main_subTitle__nWLpH {
  width: 280px;
  margin-top: 30px;
  margin-left: 10px;
}
.Main_MainTablet__xJmiN .Main_vertical__O-m14 .Main_photo__3lo9F {
  width: 90vw;
  height: 70vh;
  position: absolute;
  right: 0;
  bottom: 0;
  background-position: right 0 bottom 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 39vh;
}

.Main_MainMobileIphoneSEVertical__ZryJD {
  position: relative;
  height: calc(100vh - 228px);
}
.Main_MainMobileIphoneSEVertical__ZryJD svg {
  padding: 40px 24px 24px;
  width: 325px;
}
.Main_MainMobileIphoneSEVertical__ZryJD .Main_subTitle__nWLpH {
  width: 231px;
  padding: 0 24px;
}
.Main_MainMobileIphoneSEVertical__ZryJD .Main_photoSE__0lfex {
  width: 300px;
  height: 300px;
  position: absolute;
  right: 0;
  bottom: 0;
  background-position: right 0 bottom 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 27vh;
}

.Main_MainMobileIphoneSEHorizontal__7sWCl {
  position: relative;
  height: calc(100vh - 80px);
}
.Main_MainMobileIphoneSEHorizontal__7sWCl svg {
  padding: 40px 24px 24px;
  width: 325px;
}
.Main_MainMobileIphoneSEHorizontal__7sWCl .Main_subTitle__nWLpH {
  width: 50vw;
  padding: 10px 24px;
}
.Main_MainMobileIphoneSEHorizontal__7sWCl .Main_photoSE__0lfex {
  width: 240px;
  height: 270px;
  position: absolute;
  right: 0;
  bottom: 0;
  background-position: right 0 bottom 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 220px;
}

.Main_MainMobileIphoneProMaxVertical__oRaJd {
  position: relative;
  height: calc(100vh - 228px);
}
.Main_MainMobileIphoneProMaxVertical__oRaJd svg {
  padding: 40px 24px 24px;
  width: 370px;
}
.Main_MainMobileIphoneProMaxVertical__oRaJd .Main_subTitle__nWLpH {
  width: 270px;
  padding: 4px 24px;
}
.Main_MainMobileIphoneProMaxVertical__oRaJd .Main_photoProMax__XUIaS {
  width: 90vw;
  height: 50vh;
  position: absolute;
  right: 0;
  bottom: 0;
  background-position: right -33px bottom 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 33vh;
}

.Main_MainMobileIphoneProMaxHorizontal__pSh8D {
  position: relative;
  height: calc(100vh - 80px);
}
.Main_MainMobileIphoneProMaxHorizontal__pSh8D svg {
  padding: 40px 24px 24px;
  width: 400px;
}
.Main_MainMobileIphoneProMaxHorizontal__pSh8D .Main_subTitle__nWLpH {
  width: 50vw;
  padding: 10px 24px;
}
.Main_MainMobileIphoneProMaxHorizontal__pSh8D .Main_photoProMax__XUIaS {
  width: 250px;
  height: 300px;
  position: absolute;
  right: 0;
  bottom: 0;
  background-position: right 0 bottom 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 240px;
}`, "",{"version":3,"sources":["webpack://./src/tabs/Main/Main.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;AACF;AAEI;EACE,kBAAA;EACA,UAAA;EACA,UAAA;AAAN;AAEM;EACE,WAAA;AAAR;AAGM;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;AADR;AAKI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,qCAAA;EACA,yDAAA;EACA,4BAAA;EACA,qBAAA;AAHN;AAQI;EACE,kBAAA;EACA,UAAA;EACA,UAAA;AANN;AAQM;EACE,WAAA;AANR;AASM;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;AAPR;AAWI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,qCAAA;EACA,yDAAA;EACA,4BAAA;EACA,qBAAA;AATN;;AAcA;EACE,kBAAA;EACA,2BAAA;AAXF;AAaE;EACE,uBAAA;EACA,YAAA;AAXJ;AAcE;EACE,YAAA;EACA,eAAA;AAZJ;AAeE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,qCAAA;EACA,yDAAA;EACA,4BAAA;EACA,qBAAA;AAbJ;;AAiBA;EACE,kBAAA;EACA,0BAAA;AAdF;AAgBE;EACE,uBAAA;EACA,YAAA;AAdJ;AAiBE;EACE,WAAA;EACA,kBAAA;AAfJ;AAkBE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,qCAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;AAhBJ;;AAoBA;EACE,kBAAA;EACA,2BAAA;AAjBF;AAmBE;EACE,uBAAA;EACA,YAAA;AAjBJ;AAoBE;EACE,YAAA;EACA,iBAAA;AAlBJ;AAqBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yCAAA;EACA,yDAAA;EACA,4BAAA;EACA,qBAAA;AAnBJ;;AAuBA;EACE,kBAAA;EACA,0BAAA;AApBF;AAsBE;EACE,uBAAA;EACA,YAAA;AApBJ;AAuBE;EACE,WAAA;EACA,kBAAA;AArBJ;AAwBE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,qCAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;AAtBJ","sourcesContent":[".MainTablet {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 208px);\n  position: relative;\n\n  .horizont {\n    .text {\n      position: absolute;\n      top: 137px;\n      left: 24px;\n\n      .iconTablet {\n        width: 60vw;\n      }\n\n      .subTitle {\n        width: 280px;\n        margin-top: 30px;\n        margin-left: 10px;\n      }\n    }\n\n    .photo {\n      width: 90vw;\n      height: 70vh;\n      position: absolute;\n      right: 0;\n      bottom: 0;\n      background-position: right 0 bottom 0;\n      background-image: url(\"../../assets/images/Main-image.png\");\n      background-repeat: no-repeat;\n      background-size: 51vh;\n    }\n  }\n\n  .vertical {\n    .text {\n      position: absolute;\n      top: 117px;\n      left: 24px;\n\n      .iconTablet {\n        width: 72vw;\n      }\n\n      .subTitle {\n        width: 280px;\n        margin-top: 30px;\n        margin-left: 10px;\n      }\n    }\n\n    .photo {\n      width: 90vw;\n      height: 70vh;\n      position: absolute;\n      right: 0;\n      bottom: 0;\n      background-position: right 0 bottom 0;\n      background-image: url(\"../../assets/images/Main-image.png\");\n      background-repeat: no-repeat;\n      background-size: 39vh;\n    }\n  }\n}\n\n.MainMobileIphoneSEVertical {\n  position: relative;\n  height: calc(100vh - 228px);\n\n  svg {\n    padding: 40px 24px 24px;\n    width: 325px;\n  }\n\n  .subTitle {\n    width: 231px;\n    padding: 0 24px;\n  }\n\n  .photoSE {\n    width: 300px;\n    height: 300px;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    background-position: right 0 bottom 0;\n    background-image: url(\"../../assets/images/Main-image.png\");\n    background-repeat: no-repeat;\n    background-size: 27vh;\n  }\n}\n\n.MainMobileIphoneSEHorizontal {\n  position: relative;\n  height: calc(100vh - 80px);\n\n  svg {\n    padding: 40px 24px 24px;\n    width: 325px;\n  }\n\n  .subTitle {\n    width: 50vw;\n    padding: 10px 24px;\n  }\n\n  .photoSE {\n    width: 240px;\n    height: 270px;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    background-position: right 0 bottom 0;\n    background-image: url(\"../../assets/images/Main-image.png\");\n    background-repeat: no-repeat;\n    background-size: 220px;\n  }\n}\n\n.MainMobileIphoneProMaxVertical {\n  position: relative;\n  height: calc(100vh - 228px);\n\n  svg {\n    padding: 40px 24px 24px;\n    width: 370px;\n  }\n\n  .subTitle {\n    width: 270px;\n    padding: 4px 24px;\n  }\n\n  .photoProMax {\n    width: 90vw;\n    height: 50vh;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    background-position: right -33px bottom 0;\n    background-image: url(\"../../assets/images/Main-image.png\");\n    background-repeat: no-repeat;\n    background-size: 33vh;\n  }\n}\n\n.MainMobileIphoneProMaxHorizontal {\n  position: relative;\n  height: calc(100vh - 80px);\n\n  svg {\n    padding: 40px 24px 24px;\n    width: 400px;\n  }\n\n  .subTitle {\n    width: 50vw;\n    padding: 10px 24px;\n  }\n\n  .photoProMax {\n    width: 250px;\n    height: 300px;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    background-position: right 0 bottom 0;\n    background-image: url(\"../../assets/images/Main-image.png\");\n    background-repeat: no-repeat;\n    background-size: 240px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"MainTablet": `Main_MainTablet__xJmiN`,
	"horizont": `Main_horizont__yv9RY`,
	"text": `Main_text__wGXgG`,
	"iconTablet": `Main_iconTablet__BpIYQ`,
	"subTitle": `Main_subTitle__nWLpH`,
	"photo": `Main_photo__3lo9F`,
	"vertical": `Main_vertical__O-m14`,
	"MainMobileIphoneSEVertical": `Main_MainMobileIphoneSEVertical__ZryJD`,
	"photoSE": `Main_photoSE__0lfex`,
	"MainMobileIphoneSEHorizontal": `Main_MainMobileIphoneSEHorizontal__7sWCl`,
	"MainMobileIphoneProMaxVertical": `Main_MainMobileIphoneProMaxVertical__oRaJd`,
	"photoProMax": `Main_photoProMax__XUIaS`,
	"MainMobileIphoneProMaxHorizontal": `Main_MainMobileIphoneProMaxHorizontal__pSh8D`
};
export default ___CSS_LOADER_EXPORT___;
